import { Provider } from "jotai";
import React from "react";
import styled from "styled-components";
import useClientItem from "../useClientItem";
import CompanyItem from "./CompanyItem/CompanyItem";
import { PanelSectionTitleAbs } from "../../../../../common/layout/StyledComponents/StyledComponents";

const CompanyList = () => {
  const { client } = useClientItem();

  return (
    <div>
      <PanelSectionTitleAbs className="py-0 mx-1 mb-2">
        {client.clients.length} société{client.clients.length > 1 ? "s" : ""}
      </PanelSectionTitleAbs>
      <CompanyGrid className="mx-3 mb-3">
        {client.clients.map((company) => (
          <Provider key={`companyitem${company.id}`}>
            <CompanyItem companyData={company} />
          </Provider>
        ))}
      </CompanyGrid>
    </div>
  );
};

// Grille responsive : colonnes auto-ajustées, cartes de largeur régulière.
// align-items: stretch (défaut) → toutes les cartes d'une rangée ont la même hauteur.
const CompanyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export default CompanyList;
